module.exports = __webpack_public_path__ + "img/svg/background-user-rankings.f34daa9a802d0e326395d9ef815c105e.svg";